import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import clsx from 'clsx';
import type { ActivityDateGroup } from '@/lib/useActivityFeed';
import { ActivityCard } from './ActivityCard';

/** Tarih grubu — accordion. Bugün default açık, diğerleri kapalı.
 *  Click ile genişler/daralır. Header sticky değil (CSS basit kalsın). */
export function ActivityDateSection({ group, defaultOpen }: {
  group: ActivityDateGroup;
  defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(defaultOpen ?? group.bucket === 'today');

  return (
    <section className="mb-2">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left hover:bg-slate-50 transition"
      >
        {open ? (
          <ChevronDown size={14} className="text-slate-400 flex-shrink-0" />
        ) : (
          <ChevronRight size={14} className="text-slate-400 flex-shrink-0" />
        )}
        <h3 className="text-[12px] font-semibold text-slate-600 uppercase tracking-wider">
          {group.label}
        </h3>
        <span className="text-[11px] font-medium text-slate-400 ml-1">{group.items.length}</span>
        <div className="flex-1" />
      </button>
      {open && (
        <ul className={clsx('divide-y divide-slate-100 rounded-xl bg-surface ring-1 ring-slate-200/70 overflow-hidden mt-1')}>
          {group.items.map((item) => (
            <ActivityCard key={item.key} item={item} />
          ))}
        </ul>
      )}
    </section>
  );
}
